import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const RecognizeOrRejectOrderFilter = ({ label = "l.recognizeRejectOrder", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"protocolNumber"} label={label} {...others} />
    </>
  );
};

export default RecognizeOrRejectOrderFilter;
